import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule, routingComponent} from './app-routing.module';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HeaderComponent } from './public/header/header.component';
import { HoverAnimation } from './public/masterdata/moushover';

import { HttpClientModule } from '@angular/common/http';
import { UserService } from './shared/services/user.service';
import { CategoryComponent } from './public/category/category.component';
import { InstitutionComponent } from './public/institution/institution.component';
import { ProgramComponent } from './public/program/program.component';
import { BatchComponent } from './public/batch/batch.component';
import { CategoryTableComponent } from './private/tables/category-table/category-table.component';
import { SponserTableComponent } from './private/tables/sponser-table/sponser-table.component';
import { InstitutionTableComponent } from './private/tables/institution-table/institution-table.component';
import { ProgramTableComponent } from './private/tables/program-table/program-table.component';
import { GradeTableComponent } from './private/tables/grade-table/grade-table.component';
import { ModuleTableComponent } from './private/tables/module-table/module-table.component';
import { StudentsTableComponent } from './private/tables/students-table/students-table.component';
import { ApplicationTableComponent } from './private/tables/application-table/application-table.component';
import { BatchTableComponent } from './private/tables/batch-table/batch-table.component';
import { StudentsService } from './shared/services/students.service';
import { UserComponent } from './public/user/user.component';
import { UsermasterComponent } from './public/usermaster/usermaster.component';

import { UserTableComponent } from './private/tables/user-table/user-table.component';
import { RoleTableComponent } from './private/tables/role-table/role-table.component';
import { NotificationComponent } from './private/widget/notification/notification.component';

import { ChartsModule } from 'ng2-charts';
import { AppModule } from './app.module';


@NgModule({
  entryComponents: [NotificationComponent],
  imports: [
    
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ChartsModule,
    AppModule,
    BrowserTransferStateModule
  ],
  providers: [UserService, StudentsService],
  bootstrap: [AppComponent]
})
export class AppBrowserModule { }
